import {
   PrescriptionP1HistoryDailyGroup,
   PrescriptionP1HistoryDataAccessMode,
} from '@dreryk/egabinet-prescription-frontend-api';

import { assertUnreachable } from '@dreryk/react-common';

import { PatientDataAccessMode } from '~libs.shared.prescription';

export const getHistoricalPrescriptionDataAccessMode = (
   formAccessModeValue: PatientDataAccessMode | null
): PrescriptionP1HistoryDataAccessMode | null => {
   switch (formAccessModeValue) {
      case 'STANDARD':
      case null:
         return null;
      case 'SPECIAL':
         return 'SPECIAL';
      case 'SPECIAL_PREGNANCY':
         return 'PREGNANCY';
      default:
         return assertUnreachable(formAccessModeValue);
   }
};

export const countPrescriptions = (dailyGroups: PrescriptionP1HistoryDailyGroup[]): number =>
   dailyGroups.reduce((total, dailyGroup) => total + dailyGroup.prescriptions.length, 0);
